import { Api } from '@coderhouse/common'
import { BannerItem } from '@/models/banner'

const { VUE_APP_CH_API_BFF } = process.env

async function getBanners(country: string): Promise<BannerItem> {
  const banner = await Api.get(`${VUE_APP_CH_API_BFF}/v1/home/banner/country/${country}?context=all`)
  return new BannerItem(banner)
}

export { getBanners }
